import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { warehouseSearchRead } from "../../DataApi/warehouse/warehouseSearchRead";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";

const initialState = {
  inventoryList: [],
  inventoryTypeList: [],
  loading: "idle",
  error: null,
};

const fetchWarehouseData = createAsyncThunk(
  "warehouse/fetchData",
  async ({
    selectedView,
    model,
    company_id,
    context,
    pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },
    search = { query: "", type: "" },
    sort = { type: "", dir: "asc" },

  }) => {
    try {
      let response = await warehouseSearchRead({
        model,
        context,
        company_id,
        pagination,
        search,
        sort
      });
      response = JSON.parse(response);

      return {
        type: selectedView,
        records: response?.result?.records.reverse() || [],
        length: response?.result?.length || 0,
      };
    } catch (error) {
      console.error("An error occurred in searchRead:", error);
    }
  }
);

const WarehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseData.pending, (state) => {
        state.loading = "pending";
        state.error = null;
      })
      .addCase(fetchWarehouseData.fulfilled, (state, action) => {
        if (action?.payload?.type === "kanbanView") {
          state.inventoryTypeList = action?.payload?.records || [];
        } else {
          state.inventoryList = action?.payload?.records || [];
        }
        state.length = action?.payload?.length || 0;
        state.loading = "succeed";
        state.error = null;
      })
      .addCase(fetchWarehouseData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export const {} = WarehouseSlice.actions;
export const warehouseActions = {
  ...WarehouseSlice.actions,
  fetchWarehouseData,
};

export default WarehouseSlice.reducer;
